import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import AdvertisementDrawer from "components/drawer/AdvertisementDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewAdvertisement";
import EditDeleteButton from "components/table/EditDeleteButton";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

import { FiEye } from "react-icons/fi";
import RemarkModal from "components/modal/RemarkModal";
// internal imports


const AdvertisementTable = ({ advertisement ,perpage, currentPage,tab,      hideEdit}) => {
  const { title, serviceId,serviceBlock, handleModalOpen, handleView,handleUpdate  } = useToggleDrawer();
  // const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  // const [selectedAdvertisement, setSelectedAdvertisement] = useState(null);


  
  
  
  

  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={advertisement} />

      <MainDrawer>
        <AdvertisementDrawer id={serviceId} tab={tab} />
      </MainDrawer>

      <TableBody>
        {advertisement?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell>{(currentPage - 1) * perpage + index + 1}</TableCell>

            <TableCell className="text-sm text-center">{data.title}</TableCell>

            <TableCell className="text-sm text-center">{data.url}</TableCell>

            <TableCell>
              <img
                width={"150px"}
                className="rounded-md mx-auto"
                src={process.env.REACT_APP_API_IMAGE_URL + data.ad_image_1}
                alt="advertisementImage"
              />
            </TableCell>

            <TableCell>
              <div className="flex justify-center items-center">
                <button
                  onClick={() => handleView(data.id, "Advertisement Details")}
                  className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                >
                  <Tooltip
                    id={data.id}
                    Icon={FiEye}
                    title="ViewOrder"
                    bgColor="#34D399"
                  />
                </button>

                <EditDeleteButton
                  title={data.name}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideDelete={true}
                  hideEdit={hideEdit}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default AdvertisementTable;
